import {
  Directive,
  Input,
  OnDestroy,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { CarmResources } from '@carm/_core';
import { GroupTypes } from '@carm/_core/access-control-mgt/models/acl.model';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AccessControlService } from '../../../_core/access-control-mgt/services/access-control.service';

@Directive({
  selector: '[carm-acl-group]',
})
export class AclGroupDirective implements OnDestroy {
  private destory$ = new Subject();

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private aclService: AccessControlService
  ) {}

  /**
   * Check the resource name and current role type exist in the ACL allowed
   * configuration - if the resource is not allowed then remove the element. Behaves like *ngIf
   */
  @Input('carm-acl-group')
  set carmAclGroup(values: [ CarmResources, GroupTypes, boolean]) {
    const resource = values && values.length >= 1 ? values[0] : '';
    const groupType = values && values.length >= 2 ? values[1] : null;
    const isNativeAcl = values && values.length >= 3 ? values[2] : false;

    if (!resource || !groupType) {
      throw new Error(`Check invalid acl => resource: ${resource} group type: ${groupType}`);
    }

    this.aclService
      .isAclGroupAllowedResource(resource, groupType, isNativeAcl)
      .pipe(takeUntil(this.destory$))
      .subscribe(result => {

        if (result) {
          if (this.viewContainer.length === 0) {
            this.viewContainer.createEmbeddedView(this.templateRef); // aka *ngIf=true
          }
        } else {
          this.viewContainer.clear(); // aka *ngIf=false
        }
      });
  }

  ngOnDestroy(): void {
    this.destory$.next(true);
    this.destory$.complete();
  }
}
